import React, { useCallback } from 'react';
import MoveTo from 'moveto';
import BtnShopFilter from '../components/btn-shop-filter';
import { sendga } from '@ts/modules/sendga';
/**
 * ボタン一覧の生成
 */
const createBtns = (shopItemsOrder, onClick) => {
    return shopItemsOrder.map((orderItem) => {
        return (React.createElement(BtnShopFilter, { key: orderItem.region_name, id: orderItem.region_id, label: orderItem.region_name, onClick: () => onClick(orderItem.region_id, orderItem.region_name) }));
    });
};
const NavbarShopFilter = ({ shopItemsOrder, onSelectFilter }) => {
    const moveTo = new MoveTo();
    /**
     * ボタンクリック
     */
    const handleClickBtn = useCallback((regionID, regionName) => {
        onSelectFilter(regionID, regionName);
        // アナリティクス送信
        sendga(regionName, '地域選択');
        const targetEl = document.querySelector('#js-shop');
        if (targetEl) {
            setTimeout(() => moveTo.move(targetEl), 100);
        }
    }, [
        shopItemsOrder
    ]);
    return (React.createElement("div", { className: "bg-yellow" },
        React.createElement("div", { className: "content" },
            React.createElement("div", { className: "shoplist-title gutter py-6" }, "\u958B\u50AC\u5E97\u8217\u4E00\u89A7"),
            React.createElement("div", { className: "navbar-shoplist pb-12" }, createBtns(shopItemsOrder, handleClickBtn)))));
};
export default NavbarShopFilter;
